export default __webpack_public_path__ + "static/media/HouseFinancialOrange.c1f4b329.svg";